export default __webpack_public_path__ + "locales/about.kk.json";